import routerOptions0 from "/nuxtWeb/node_modules/.pnpm/nuxt@3.21.2_@parcel+watcher@2.5.6_@types+node@25.5.0_@vue+compiler-sfc@3.5.30_cac@6.7.1_b6a7b4bcef19d1331ec95ac1081c44f6/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}